<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="none"
        viewBox="0 0 16 16"
        :aria-labelledby="props.ariaLabelledby"
        :aria-hidden="!props.ariaLabelledby"
        role="img"
    >
        <path fill="currentColor" d="m6.367 12-3.8-3.8.95-.95 2.85 2.85 6.116-6.117.95.95L6.367 12Z" />
    </svg>
</template>

<script setup lang="ts">
type CheckIconProps = {
    ariaLabelledby?: string;
};

const props = defineProps<CheckIconProps>();
</script>
